module.exports = __webpack_public_path__ + "img/BBowman64_ua.ef2c7f6c.webp";